import { WsRequest } from '../WsRequest';
import { RestJsonWsClient } from '../RestJsonWsClient';
import { GenericEnv } from '../../webservice/GenericEnv';
import { amorphicStatic, property } from '@haventech/amorphic';
import { Utils } from '../../Utils';
import { GiactResponseCodes, GiactWebDebitResponse } from '../../../../coverpath-common/js/interfaces/CoverpathTypes';
import { UICategory, UILoggerSingleton } from '../../logger/UILoggerSingleton';

export class VerifyGiactWebDebitClient extends WsRequest {
  static readonly requestName: string = 'VerifyGiactWebDebit';
  static async buildRequest(requestPayload, svcConfig): Promise<VerifyGiactWebDebitClient> {
    const request = await VerifyGiactWebDebitRequest.buildRequest(requestPayload);
    const client = VerifyGiactWebDebitClient.getClient(svcConfig);
    return new VerifyGiactWebDebitClient(client, request);
  }

  static getClient(svcConfig) {
    return VerifyGiactWebDebitWsClient.new(
      {
        serviceName: 'verify', // service name in URL
      },
      svcConfig,
      VerifyGiactWebDebitClient.requestName
    );
  }

  static async invokeVerifyCall(policy, requestPayload): Promise<GiactWebDebitResponse> {
    try {
      const giactSvgConfig = amorphicStatic.config.nconf.get('wsclients')[VerifyGiactWebDebitClient.requestName];
      const giactRequest = await VerifyGiactWebDebitClient.buildRequest(requestPayload, giactSvgConfig);
      const wsclient = giactRequest.client;
      const response = (await wsclient.invoke(
        giactRequest.data.format(),
        null,
        policy.getRunModes()
      )) as GiactWebDebitResponse;
      return response;
    } catch (error) {
      const err = {
        isHumanRelated: false,
        name: error?.name,
        message: error?.message,
        stack: error?.stack,
      };
      UILoggerSingleton.getInstance().error({
        module: 'VerifyGiactWebDebitClient',
        function: 'invokeVerifyCall',
        category: UICategory.request,

        error: err,
      });
      return {
        status: 'pass',
        normalizedResponseCode: GiactResponseCodes.SERVICE_OFF,
        sourceResponseCode: GiactResponseCodes.SERVICE_OFF,
      };
    }
  }
}

export class VerifyGiactWebDebitWsClient extends RestJsonWsClient {
  static new(opts, svcCfg, requestName, requestGroup?) {
    return new VerifyGiactWebDebitWsClient(requestName, requestGroup).init(opts, svcCfg);
  }
}

export class VerifyGiactWebDebitRequest extends GenericEnv {
  static async buildRequest(request): Promise<VerifyGiactWebDebitRequest> {
    return Promise.resolve(VerifyGiactWebDebitRequest.new(request));
  }

  @property()
  refId: string;

  constructor() {
    super();
  }

  static new(doc) {
    return new VerifyGiactWebDebitRequest().init(doc);
  }

  init(doc?, uuid = Utils.generateUuidV4()) {
    super.init(doc);

    this.refId = `${uuid}`;
    return this;
  }

  getConvRefId() {
    return this.refId;
  }
}
